var MDB = window.MDB || {};;

(function ($) {
    $.extend(MDB,
        {
            
            initBootstrapSwitches: function initBootstrapSwitches(subContainer, onInit, onStateChange) {
                var labelWidth = 14;

                var handleWidth = $('.fullwidth-switch').data('handle-width');
                if (handleWidth === undefined) {
                    // Container border + 2 * handle padding + 2 * label padding + label width.
                    var nonHandleWidth = 2 + 2 * 12 + 2 * 6 + labelWidth;
                    handleWidth = $('.fullwidth-switch').parent().width() - nonHandleWidth;
                }
                
                $('.fullwidth-switch').data('handle-width', handleWidth);

                
                
                subContainer.find('[type=checkbox]')
                    .attr('data-role', 'switch')
                    .bootstrapSwitch({
                        labelWidth: labelWidth,
                        labelText: '<i class="fa fa-exchange">',
                        onColor: 'default',
                        onInit: onInit,
                        onSwitchChange: onStateChange || onInit
                    })
                    .on('switchChange.bootstrapSwitch', function (event) {
                        $(event.target).change();
                    });

                // Create switch/colorpicker hybrid control.
                $('.color-switch').closest('.bootstrap-switch-wrapper')
                    .each(function(index, colorSwitch) {
                        var self = $(colorSwitch);
                        var colorPicker = self.nextAll('.k-colorpicker');
                        
                        if (colorPicker.length === 1) {
                            var switchElement = self.find('input[type="checkbox"].color-switch');
                            var switchOff = self.find('.bootstrap-switch-handle-off');
                            
                            colorPicker.removeClass('hidden').width(switchOff.outerWidth());
                            self.find('.bootstrap-switch-container').append(colorPicker);
                            switchOff.remove();

                            self.find('.bootstrap-switch-label').on('click', function () {
                                var state = switchElement.bootstrapSwitch('state');
                                if (!state) {
                                    switchElement.bootstrapSwitch('state', true);
                                }
                            });
                        }
                    });
            },
            initBootstrapSwitchesDependantControls: function(subContainer, onInit, onStateChange){
                onInit = _.isFunction(onInit) || $.noop;
                onStateChange = _.isFunction(onStateChange) || onInit;


                var hideDependantControls = function(){
                    var self = $(this);
                    var checked = self.prop('checked');
                    var wrapper = self.parents('.enable-switch-wrapper').first();

                    var isWrapper = wrapper.length > 0;
                    var collapsableBlock = self.closest('.collapsable-block');

                    var dependentControlsContainers = isWrapper ? 
                        $(wrapper.data('target')) : 
                        collapsableBlock.children('.dependent-controls') || 
                    collapsableBlock.children('.dependent-controls');

                    if (self.is('[name$="Visible"]') || self.hasClass('act-name-visible')) {
                        if (checked) {
                            dependentControlsContainers.slideDown();
                        } else {
                            dependentControlsContainers.slideUp();
                        }
                    }

                    if (self.is('[name$=".Hide"]') || self.hasClass('act-name-hide')) {
                        if (checked) {
                            dependentControlsContainers.slideUp();
                        } else {
                            dependentControlsContainers.slideDown();
                        }
                    }
                };

                MDB.initBootstrapSwitches(subContainer, 
                    function(){
                        hideDependantControls.apply(this, arguments); 
                        onInit.apply(this, arguments) 
                    },
                    function(){
                        hideDependantControls.apply(this, arguments); 
                        onStateChange.apply(this, arguments) 
                    } 
                );
            }
        });
})(jQuery);